import {
  Card,
  CardHeader,
  Media,
} from "reactstrap";
import { useState, useEffect } from "react";

import { DEPOSIT_REPORT } from "../../../services/CONSTANTS";
import { getApiDataService } from "../../../services/apiServices";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { DataTable, FilterBar } from "components/shared";

const DEPOSIT_COLUMNS = [
  { key: "index", label: "#", className: "text-center" },
  { key: "provider", label: "Provider Name", className: "text-center" },
  { key: "count", label: "Deposit Count", className: "text-center" },
  { key: "amount", label: "Deposit Amount", className: "text-center" },
];

const FinancialReport = () => {
  const [depositReports, setDepositReports] = useState([]);
  const [isLoadingDepositReport, setIsLoadingDepositReport] = useState(false);

  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();
  const [depositStartDate, setDepositStartDate] = useState(start);
  const [depositEndDate, setDepositEndDate] = useState(end);

  const [dateChangeEvent, setDateChangeEvent] = useState(false);

  useEffect(() => {
    fetchDepositReport();
  }, [dateChangeEvent]);

  const handleDepositCallback = (start, end) => {
    setDepositStartDate(start.toISOString());
    setDepositEndDate(end.toISOString());
    setDateChangeEvent(!dateChangeEvent);
  };

  let fetchDepositReport = async () => {
    setIsLoadingDepositReport(true);
    try {
      let res = await getApiDataService(
        `${DEPOSIT_REPORT}?start_date=${depositStartDate}&end_date=${depositEndDate}`
      );
      setDepositReports(res.data || []);
    } catch (err) {
      console.log("Error Loading Deposit Report:", err);
      setDepositReports([]);
    }
    setIsLoadingDepositReport(false);
  };

  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <FilterBar title="App/Web Deposit Report">
            <DateRangePicker onCallback={handleDepositCallback}>
              <input
                className="form-control akh-filter-width"
                placeholder="Select date range"
                aria-label="Date range"
              />
            </DateRangePicker>
          </FilterBar>
        </CardHeader>
        <DataTable
          columns={DEPOSIT_COLUMNS}
          data={depositReports}
          isLoading={isLoadingDepositReport}
          emptyMessage="No records found"
          renderRow={(item, index) => (
            <tr key={item?.provider_name || index}>
              <td className="text-center" scope="row">
                {index + 1}
              </td>
              <td className="text-center" scope="row">
                <Media
                  className="align-items-center"
                  style={{ marginLeft: "100px" }}
                >
                  <a
                    className="avatar rounded-circle mr-3"
                    href="#"
                    onClick={(e) => e.preventDefault()}
                  >
                    <img
                      alt=""
                      src={item?.provider_logo}
                      style={{ width: "40px" }}
                    />
                  </a>
                  <span className="mb-0 text-sm">{item?.provider_name}</span>
                </Media>
              </td>
              <td className="text-center font-mono">
                {item?.total_deposit_count?.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_deposit_amount?.toLocaleString("en-US")}
              </td>
            </tr>
          )}
          footer={
            depositReports.length > 0 ? (
              <tr style={{ borderTop: "2px solid #1a174d" }}>
                <td className="text-right bg-gradient-default shadow text-white">
                  Total :
                </td>
                <td></td>
                <td className="text-center font-mono">
                  {depositReports
                    .reduce((a, b) => a + b.total_deposit_count, 0)
                    .toLocaleString("en-US")}
                </td>
                <td className="text-center font-mono">
                  {depositReports
                    .reduce(
                      (a, b) =>
                        (b.provider_name.includes("SCB Bank") ||
                          b.provider_name.includes("Bangkok Bank")) == false
                          ? a + b.total_deposit_amount
                          : a + 0,
                      0
                    )
                    .toLocaleString("en-US")}{" "}
                  MMK |
                  {depositReports
                    .reduce(
                      (a, b) =>
                        (b.provider_name.includes("SCB Bank") ||
                          b.provider_name.includes("Bangkok Bank")) == true
                          ? a + b.total_deposit_amount
                          : a + 0,
                      0
                    )
                    .toLocaleString("en-US")}{" "}
                  THB
                </td>
              </tr>
            ) : null
          }
        />
      </Card>
    </>
  );
};

export default FinancialReport;
